<div *ngIf="loading" class="preload">
  <div class="preload-image">
    <img src="assets/img/preloader.gif"/>
    <p class="loading-div">{{'LOADING' | translate }} ...</p>
  </div>

</div>

<div *ngIf="loading && receiveOrder" class="preload">
  <div class="preload-image">
    <img src="assets/img/preloader.gif"/>
    <p class="loading-div">{{'LOADING' | translate }} ...</p>
    <p-progressBar [value]="value"></p-progressBar>
  </div>

</div>
